<div class="book-confirmation-container">
  <div class="book-confirmation-overlay"></div>
  <div class="container" [dir]="languageService.getDir()">
    <div class="main-row" *ngIf="order">
      <div class="text-center text-uppercase">
        <h2>{{ order.office.city }}, {{ order.office.address }}</h2>
      </div>
      <div class="content-divider"></div>
      <div class="row">
        <div class="col-md-2" [class.text-right]="languageService.isCurrent('Hebrew')">
          <div class="booking-details-title">{{ 'BOOKING_CONFIRMATION.BOOKING_DETAILS' | translate }}</div>
          <ul>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_START' | translate }}</li>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_END' | translate }}</li>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_OPTION' | translate }}</li>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_UNIT' | translate }}</li>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_MONTH_SUBSCRIBE' | translate }}</li>
          </ul>
        </div>
        <div class="col-md-8" [class.text-right]="languageService.isCurrent('Hebrew')">
          <div class="booking-details-title">&nbsp;</div>
          <ul>
            <li>{{ order.start | date:'EEEE dd.MM.yyyy HH:mm' }}</li>
            <li>{{ order.end | date:'EEEE dd.MM.yyyy HH:mm' }}</li>
            <li>{{ 'ENUM.BOOKING_OPTION.' + order.bookingOption | translate }}</li>
            <li>{{ order.room.name }}</li>
            <li>{{ order.monthSubscribe ? 'Yes' : 'No' }}</li>
          </ul>
        </div>
        <div class="col-md-2" [class.text-right]="languageService.isCurrent('ENGLISH')">
          <h2 class="text-uppercase">{{ 'BOOKING_CONFIRMATION.BOOKING' | translate }}</h2></div>
      </div>
      <div class="row">
        <div class="col-md-8" [class.text-right]="languageService.isCurrent('Hebrew')">
          <div class="booking-details-title">{{ 'BOOKING_CONFIRMATION.BOOKED_BY' | translate }}</div>
          <ul>
            <li>{{ order.user.firstname }} {{ order.user.lastname }}</li>
            <li dir="ltr">{{ order.user.phone }}</li>
          </ul>
        </div>
        <div class="col-md-2" [class.text-right]="languageService.isCurrent('Hebrew')">
          <ul>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING' | translate }} #</li>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_DATE' | translate }}</li>
            <li>{{ 'BOOKING_CONFIRMATION.BOOKING_STATUS' | translate }}</li>
          </ul>
        </div>
        <div class="col-md-2" [class.text-right]="languageService.isCurrent('Hebrew')">
          <ul>
            <li>{{ order.id }}</li>
            <li>{{ order.createdDate | date:'dd.MM.yy HH:mm' }}</li>
            <li><h5><span class="badge" [ngClass]="bookingBadgeClass">{{ order.status }}</span></h5></li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col table-responsive-lg">
          <table class="table" [class.text-right]="languageService.isCurrent('Hebrew')">
            <thead>
              <th>{{ 'BOOKING_CONFIRMATION.BOOKING_DESCRIPTION' | translate }}</th>
              <th>{{ 'BOOKING_CONFIRMATION.BOOKING_AMOUNT' | translate }}</th>
            </thead>
            <tbody>
              <tr>
                <td dir="ltr">{{ order.duration }} {{ order.durationUnit }} x {{ order.transaction.price }}{{ order.transaction.currency }} </td>
                <td>{{ order.transaction.price * order.duration }}</td>
              </tr>
              <tr *ngIf="order.coupon">
                <td>{{ 'BOOKING_CONFIRMATION.BOOKING_DISCOUNT_COUPON' | translate }}</td>
                <td>{{ discountValue() }}</td>
              </tr>
              <tr *ngIf="!order.coupon && (order.transaction.price - order.transaction.amount) > 0">
                <td>{{ 'BOOKING_CONFIRMATION.BOOKING_DISCOUNT' | translate }}</td>
                <td>{{ order.transaction.price - order.transaction.amount }}</td>
              </tr>
              <tr class="total-row">
                <td>{{ 'BOOKING_CONFIRMATION.BOOKING_TOTAL' | translate }}</td>
                <td>{{ order.transaction.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="w-100">
        <div class="alert alert-danger" *ngIf="isError && errorMessage">Error: {{errorMessage}}</div>
      </div>
      <div class="w-100 text-center" *ngIf="order.status === 'PENDING'">
        <div class="text-center">
          <button type="button" class="btn button-cancel secondary-button"
                  (click)="cancel(order)">{{ 'BUTTON.CANCEL' | translate }}</button>
          <button type="button" class="btn button-pay primary-button"
                  [disabled]="order.transaction.status != 'UNPAID'"
                  (click)="checkout(order)">{{ 'BUTTON.PAY_NOW' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
